// extracted by mini-css-extract-plugin
export default {"add-branch-grp-save-button-wrapper":"addBranchGroup_add-branch-grp-save-button-wrapper__nBqtd","branch-grp-detail-label":"addBranchGroup_branch-grp-detail-label__kOf6d"};